// import { Storage } from "aws-amplify"; //Storage doesnt allow access to other buckets
import AWS, { S3 } from "aws-sdk";

const BUCKET_NAME = "dcmtenant";
const REGION = "ap-southeast-2";
const POOL_ID = "ap-southeast-2:09a57bf1-0b6a-439a-b944-69dc6394fa95";
const S3URL = "https://s3-ap-southeast-2.amazonaws.com/dcmtenant/";

//Setup S3 with Identity pool Id (CALL THIS before using the service)
let cachedS3: AWS.S3 | undefined;
export async function configureS3(): Promise<AWS.S3> {
  return new Promise((res, rej) => {
    if (cachedS3) {
      res(cachedS3);
      return;
    }
    AWS.config.region = REGION;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: POOL_ID,
    });
    const credentials = AWS.config.credentials as AWS.Credentials;
    credentials.get(err => {
      if (err) {
        rej(err);
        return;
      }
      const s3 = new S3({
        params: { Bucket: BUCKET_NAME },
      });
      cachedS3 = s3;
      res(s3);
      return;
    });
  });
}

class StorageAPI {
  constructor() {}

  signURL(imgUrl: string): string {
    //Uses the s3 object that has been setup in index.tsx
    if (!cachedS3) return "";
    if (!imgUrl) return ""; //If no image just return empty string
    try {
      const url = cachedS3.getSignedUrl("getObject", {
        Bucket: BUCKET_NAME,
        Key: imgUrl.replace(S3URL, ""),
      });
      return url;
    } catch (error) {
      console.log(error);
      return "";
    }
  }
}
export default new StorageAPI();
